import Repository, {baseUrl} from './Repository';

export async function createProduct(token, formData, productSectors, productImages, recommendationLetters, productDocs) {
    const endPoint = `/product`;

    const productSectorIds = productSectors.map(sector => sector.id);
    const productImageIds = productImages.map(image => image.path);
    const recommendationLetterIds = recommendationLetters.map(letter => letter.path);
    const productDocIds = productDocs.map(doc => doc.path);

    const payload = {
        name: formData.productName,
        type: formData.productType === "0" ? 'PRODUCT' : 'SERVICE',
        description: formData.description,
        productSectors: productSectorIds,
        fileUrls: productImageIds,
        coverPhotoUrl: formData.coverPhoto,
        validDate: formData.validityDate,
        price: formData.price,
        openForDiscount: formData.discountOption,
        minimumQuantity: formData.minimumQuantity,
        unit: formData.unit,
        currency: formData.currency,
        totalPrices: formData.minimumOrderQuantities, // Ensure this is a valid object
        documents: productDocIds,
        recommendations: recommendationLetterIds,
        keywords: formData.keywords
    };
    try {
        const response = await Repository.post(`${baseUrl}${endPoint}`, payload, {
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                token: token,
            }
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function getProducts(token) {
    const endPoint = `/product`;
    try {
        const response = await Repository.get(`${baseUrl}${endPoint}`, {
            headers: {
                token: token,
            }
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function getProductById(token, id) {
    const endPoint = `/product/${id}`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error));
            return {code: 1001, message: error.message};
        });
}

export async function getCompanyDocuments(token, companyId) {
    const endPoint = `/company/product/documents/${companyId}`;
    try {
        const response = await Repository.get(`${baseUrl}${endPoint}`, {
            headers: {
                token: token,
            }
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function addDocument(token, type, url, companyId) {
    let endPoint;
    if (type === 'distributor') {
        endPoint = `/company/product/distributionDocuments/${companyId}?url=${url}`;
    } else if (type === 'certificates') {
        endPoint = `/company/product/certificatesAndLicenses/${companyId}?url=${url}`;
    } else if (type === 'contracts') {
        endPoint = `/company/product/contractsAndReferencesForSimilarWorks/${companyId}?url=${url}`;
    }
    try {
        const response = await Repository.post(`${baseUrl}${endPoint}`, {}, {
            headers: {
                token: token,
            }
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function deleteDocument(token, type, url, companyId) {
    let endPoint;
    if (type === 'distributor') {
        endPoint = `/company/product/distributionDocuments/${companyId}?url=${url}`;
    } else if (type === 'certificates') {
        endPoint = `/company/product/certificatesAndLicenses/${companyId}?url=${url}`;
    } else if (type === 'contracts') {
        endPoint = `/company/product/contractsAndReferencesForSimilarWorks/${companyId}?url=${url}`;
    }
    try {
        const response = await Repository.delete(`${baseUrl}${endPoint}`, {
            headers: {
                token: token,
            }
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function searchProduct(token, keyword, wsIds = [], hasCerts = null, hasContracts = null) {
    let endPoint = `/product/search?keyword=${encodeURIComponent(keyword)}`;

    if (wsIds.length > 0) {
        endPoint += wsIds.map(id => `&wsId=${id}`).join('');
    }
    if (hasCerts !== null) {
        endPoint += `&hasCerts=${hasCerts}`;
    }
    if (hasContracts !== null) {
        endPoint += `&hasContracts=${hasContracts}`;
    }

    console.log(endPoint);

    try {
        const response = await Repository.get(`${baseUrl}${endPoint}`, {
            headers: {
                token: token,
            }
        });
        console.log(response);
        return response.data ? response.data : { code: 1000, message: response.statusText };
    } catch (error) {
        console.error(JSON.stringify(error));
        return { code: 1001, message: error.message };
    }
}


export async function updateProductById(token, product) {
    const endPoint = `/product/update`
    try {
        const response = await Repository.put(`${baseUrl}${endPoint}`, product, {
            headers: {
                token: token,
                'Content-Type': 'application/json;charset=utf-8',
            }
        });
        console.log(response);
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function publishProduct(token,id){
    const endPoint = `/product/publish/${id}`
    try {
        const response = await Repository.post(`${baseUrl}${endPoint}`, null,{
            headers: {
                token: token,
            }
        });
        console.log(response);
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function deleteProduct(token,id){
    const endPoint = `/product/${id}`
    try {
        const response = await Repository.delete(`${baseUrl}${endPoint}`,{
            headers: {
                token: token,
            }
        });
        console.log(response);
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function advertiseProduct(token, productId, workingSectorIds) {
    const queryParams = workingSectorIds.map(id => `workingSectorIds=${id}`).join('&');
    const endPoint = `/product/advertise-product/${productId}?${queryParams}`;

    try {
        const response = await Repository.post(`${baseUrl}${endPoint}`, null, {
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                token: token,
            }
        });
        return response.data ? response.data : { code: 1000, message: response.statusText };
    } catch (error) {
        console.error(JSON.stringify(error));
        return { code: 1001, message: error.message };
    }

}
export async function getNewInquiry(token) {

    const endPoint = `/product/has-new-inquiry`;

    try {
        const response = await Repository.get(`${baseUrl}${endPoint}`,  {
            headers: {
                token: token,
            }
        });
        return response.data ? response.data : { code: 1000, message: response.statusText };
    } catch (error) {
        console.error(JSON.stringify(error));
        return { code: 1001, message: error.message };
    }

}